import { View } from "@tarojs/components";
import React, { ReactNode, useMemo, useState } from "react";
import classNames from "classnames";

import "./index.scss";
import { XHComponentCommonProps } from "../../types";

export type SwitchProps = {
  checked?: boolean;
  checkedText?: ReactNode;
  uncheckedText?: ReactNode;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
} & XHComponentCommonProps;

const Switch: React.FC<SwitchProps> = props => {
  const {
    checked = false,
    checkedText = "",
    uncheckedText = "",
    onChange,
    className,
    disabled,
  } = props;

  const [innerChecked, setInnerChecked] = useState(checked);

  const handleCheckedChange = () => {
    if (disabled) return;
    setInnerChecked(old => {
      onChange?.(!old);
      return !old;
    });
  };

  const checkedInner = useMemo(() => {
    if (innerChecked) return checkedText;
    return uncheckedText;
  }, [innerChecked, checkedText, uncheckedText]);

  return (
    <View
      className={classNames(
        "xh-switch",
        { checked: innerChecked },
        { disabled },
        className
      )}
      onClick={handleCheckedChange}
    >
      <View className="xh-switch-control"></View>
      <View className="xh-switch-inner">{checkedInner}</View>
    </View>
  );
};

export default Switch;
